import { cva, VariantProps } from 'class-variance-authority';

const surfaceVariants = cva('relative w-full bg-base-neutral-white rounded-md', {
  variants: {
    padding: {
      xxs: 'p-xxs',
      none: 'p-none',
    },
  },
  defaultVariants: {
    padding: 'xxs',
  },
});
type SurfaceVariants = VariantProps<typeof surfaceVariants>;

type SurfaceProps = React.PropsWithChildren & SurfaceVariants & React.HTMLAttributes<HTMLDivElement>;

const Surface = ({ children, padding, className, ...props }: SurfaceProps) => {
  return (
    <section
      aria-label={props['aria-label']}
      className={surfaceVariants({
        padding,
        className,
      })}
    >
      {children}
    </section>
  );
};

export default Surface;
